import React, { useState } from 'react'
import Table from 'react-bootstrap/Table'
import Row from 'react-bootstrap/Row'
import Col from 'react-bootstrap/Col'
import Card from 'react-bootstrap/Card'
import UserBadges from 'duties/employees/UserBadges'
import { usePermissionEmployees } from 'api/hooks/use-permission-employees'
import TableFooter from 'shared/tables/table-footer'
import MutedText from 'shared/forms/muted-text'

function EmployeesTab({ permissionId }) {
  const defaultParams = {
    permission_id: permissionId,
    page: 1,
    perPage: 25,
    isExpansive: true
  }

  const [params, setParams] = useState(defaultParams)

  const { isSuccess, data: employees } = usePermissionEmployees({ params })

  return (
    <Row>
      <Col sm={12}>
        <Card className="border">
          <Card.Header className="bg-white">
            <Row>
              <Col sm="auto">
                <div className="text-info">Users</div>
              </Col>
              <Col sm="auto">
                <div className="form-check form-switch">
                  <input
                    className="form-check-input"
                    type="checkbox"
                    id="show-non-zero-values"
                    onChange={(e) =>
                      setParams({ ...params, isExpansive: e.target.checked })
                    }
                    checked={params.isExpansive}
                  />
                  <label
                    className="form-check-label"
                    for="show-non-zero-values"
                  >
                    Expansive
                  </label>
                </div>
              </Col>
            </Row>
          </Card.Header>

          <Card.Body>
            {/* TODO: Consolidate Employee table */}
            <Table responsive size="sm">
              <thead>
                <tr>
                  <th>Users</th>
                  <th>Department</th>
                  <th>Value</th>
                  <th>From Role</th>
                </tr>
              </thead>
              <tbody>
                {isSuccess &&
                  employees.data.map((employee) => (
                    <tr key={`employee-${employee.external_id}`}>
                      <td>
                        {employee.external_id}
                        <UserBadges user={employee} />
                      </td>
                      <td>
                        <MutedText className="ms-2">
                          {employee.department_name}
                        </MutedText>
                      </td>
                      <td>{employee.permission_value}</td>
                      <td>
                        {!employee.from_role ? 'MULTIPLE' : employee.from_role}
                      </td>
                    </tr>
                  ))}
              </tbody>
            </Table>
          </Card.Body>
        </Card>

        <div className="mt-4">
          {isSuccess && (
            <TableFooter
              setParams={setParams}
              params={params}
              meta={employees.meta}
            />
          )}
        </div>
      </Col>
    </Row>
  )
}

export default EmployeesTab
